import axios from "axios";
import { 
    APPROVE_API_REQUEST,
    DELETE_API_REQUEST,
    DENY_API_REQUEST,
    SET_LOADER_SITES,
    CATCH_ERROR_SITES,
    FETCH_SITES,
    FETCH_API_GROUPS,
    RESET_ACTION_SITES
} from "./type";
import { API_PATHS_SITES } from "./constant";

// export const setLoader = (loader) => (dispatch) => {
//     dispatch({ type: SET_LOADER_SITES, payload: loader })
// }

// export const resetAction = () => (dispatch) => {
//   dispatch({ type: RESET_ACTION_SITES, payload: {} });
// };

export const fetchApiGroups = (currentSite) => {
  // const addId = id ? `&id=${id}` : "";
  return (dispatch) => {
    axios
      .get(`${API_PATHS_SITES.SITE_PAGE_API}/${currentSite}`)
      .then((res) => {
        console.log("api group list ",res);
        dispatch({ type: FETCH_API_GROUPS, payload: { data: res.data }});
      })
      .catch((err) => {
        dispatch({ type: CATCH_ERROR_SITES, payload: { data: err.response?.data?.error, status: false }});
      })
  }
}

export const fetchSites = () => {
  return (dispatch) => {
    axios
      .get(`${API_PATHS_SITES.GET_SITES_API}`)
      .then((res) => {
        console.log("Site list ",res);
        dispatch({ type: FETCH_SITES, payload: { data: res.data }});
      })
      .catch((err) => {
        dispatch({ type: CATCH_ERROR_SITES, payload: { data: err.response?.data?.error, status: false }});
      })
  }
}

export const approveRequest = (api, type) => {
  return (dispatch) => {
    axios
      .put(`${API_PATHS_SITES.APPROVE_DENY_API}`, {
        apiId: api.apiId,
        domain: api.domain,
        publishingDetails: [
          {
            site: api.site,
            apiGroup: api.apiGroup,
            requesterName: api.requesterName,
            requesterEmail: api.requesterEmail
          }
        ],
        status: type,
        reason: ""
      })
      .then((res) => {
          console.log("approve_request ",res);
        dispatch({
          type: APPROVE_API_REQUEST,
          payload: {
            data: res.data,
          },
        })
      })
      .catch((err) => {
        dispatch({
          type: CATCH_ERROR_SITES,
          payload: {
            data: err.response?.data?.error,
            status: false
          },
        })
      })
  }
}

export const denyRequest = (api, type, reason) => {
  return (dispatch) => {
    axios
    .put(`${API_PATHS_SITES.APPROVE_DENY_API}`, {
        apiId: api.apiId,
        domain: api.domain,
        publishingDetails: [
          {
            site: api.site,
            apiGroup: api.apiGroup,
            requesterName: api.requesterName,
            requesterEmail: api.requesterEmail
          }
        ],
        status: type,
        reason: reason
    })
      .then((res) => {
          console.log("deny_request ",res);
        dispatch({
          type: DENY_API_REQUEST,
          payload: {
            data: res.data,
          },
        })
      })
      .catch((err) => {
        dispatch({
          type: CATCH_ERROR_SITES,
          payload: {
            data: err.response?.data?.error,
            status: false
          },
        })
      })
  }
}

export const deleteRequest = (api) => {
  return (dispatch) => {
    axios
      .delete(`${API_PATHS_SITES.SITE_PAGE_API}/delete/${api.apiDetailsId}`)
      .then((res) => {
          console.log("delete_request ",res);
        dispatch({
          type: DELETE_API_REQUEST,
          payload: {
            data: res.data,
            status: false
          },
        })
      })
      .catch((err) => {
        dispatch({
          type: CATCH_ERROR_SITES,
          payload: {
            data: err,
            status: false
          },
        })
      })
  }
}